// L-ASS.1 FRONT-I (D-ASS.14a): aviso de contrato assinado tem ícone próprio, pela action do metadata
export const getNotificationIcon = (type: string, metadata?: { action?: string } | null): string => {
  if (metadata?.action === 'contract_signed') return '✍️';
  switch (type) {
    case 'low_stock':
    case 'low_rental_stock':
      return '📦';
    case 'rental_expiring':
      return '⏰';
    case 'loan_overdue':
      return '⚠️';
    case 'rental_collection':
      return '🚛';
    case 'maintenance_due':
      return '🔧';
    case 'customer_sale_by_other':
      return '🔔';
    case 'customer_added_to_portfolio':
      return '👥';
    case 'inactive_customer_returned':
      return '🎉';
    case 'objective_near_completion':
      return '🎯';
    case 'customer_needs_contact':
      return '⚠️';
    case 'customer_unassigned_inactivity':
      return '❌';
    case 'manager_contact_alert':
      return '📊';
    case 'weekly_performance_report':
      return '📈';
    case 'pix_confirmed':
      return '💰';
    case 'new_purchase_invoice':
      return '🧾';
    case 'system_update':
      return '🔄';
    case 'task_assigned':
      return '📋';
    case 'task_completed':
      return '✅';
    case 'task_unblocked':
      return '🔓';
    default:
      return '🔔';
  }
};

export const getSeverityColor = (severity: string): string => {
  switch (severity) {
    case 'critical':
      return 'text-destructive';
    case 'warning':
      return 'text-orange-500';
    default:
      return 'text-foreground';
  }
};

export const getSeverityLabel = (severity: string): string => {
  switch (severity) {
    case 'critical':
      return 'Crítico';
    case 'warning':
      return 'Aviso';
    case 'info':
      return 'Info';
    default:
      return 'Info';
  }
};
